import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';

export const CountryForm = ({ loading, handleSubmit }) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="País" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="País"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código del país" required>
          <Field
            name="countryCode"
            component={TextInput}
            type="text"
            placeholder="Código del país"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

CountryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ LocationUnit }) => ({
  loading: LocationUnit.Country.getIn(['current', 'activity']),
});

const formComponent = reduxForm({
  form: 'CountryForm',
})(CountryForm);

export default connect(mapStateToProps)(formComponent);
